import styled from 'styled-components';
import { sidenavTokens } from '../../tokens';

export const StyledSideNavContentContainer = styled.div`
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: ${sidenavTokens.WrapperPaddingBottomBaseDefault};
  padding-left: ${sidenavTokens.WrapperPaddingLeftBaseDefault};
  padding-right: ${sidenavTokens.WrapperPaddingRightBaseDefault};
`;
